/* ============================================================
   NORTHSHEEP — "14 more brown ones", counted for real.

   The sold-out panel is rendered by Liquid with a link into the collection
   this piece came from, filtered to its colour and — when the piece came in
   only one size — that size. What Liquid cannot know is whether anything is
   actually THERE: a filtered count needs the filter to run.

   So the count is fetched, from the same handles-only view the previous/next
   arrows use (templates/collection.ns-handles.liquid, about 7KB for 250).
   Three things can come back:

     - some pieces  : the label says how many, and the link stands.
     - none at that SIZE : the size is dropped and it counts again — a shopper
                      who cannot have this hide in XL would still like to see
                      the brown ones.
     - none at all  : the colour goes too, and the link becomes the whole
                      collection. Better a wide door than a locked one.

   It never leaves a number on screen that it has not counted.
   ============================================================ */
(function () {
  'use strict';

  var link = document.querySelector('[data-ns-soldout-link]');
  if (!link || !window.fetch) return;

  var label = link.querySelector('[data-ns-soldout-label]');
  var base = link.getAttribute('data-collection');
  var colour = link.getAttribute('data-colour') || '';
  var size = link.getAttribute('data-size') || '';
  var COLOUR_KEY = 'filter.p.m.northsheep.filter_colour';
  var SIZE_KEY = 'filter.p.m.northsheep.filter_size';

  function url(withColour, withSize) {
    var u = base + '?view=ns-handles';
    if (withColour && colour) u += '&' + COLOUR_KEY + '=' + encodeURIComponent(colour);
    if (withSize && size) u += '&' + SIZE_KEY + '=' + encodeURIComponent(size);
    return u;
  }

  function count(u) {
    return fetch(u, { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (d) {
        /* The view's own total, not the handles it lists (audit, 2 Oct 2026):
           one page holds 250 at most, and Kuhfelle has 287. null when nothing
           was counted, so a failed request no longer printed "Browse all 0". */
        if (!d) return null;
        if (typeof d.total === 'number') return d.total;
        return d.handles ? d.handles.length : null;
      })
      .catch(function () {
        return null;
      });
  }

  function write(tpl, n) {
    if (!label || !tpl) return;
    label.textContent = tpl.replace('[count]', n);
  }

  function href(withColour, withSize) {
    var u = base;
    var q = [];
    if (withColour && colour) q.push(COLOUR_KEY + '=' + encodeURIComponent(colour));
    if (withSize && size) q.push(SIZE_KEY + '=' + encodeURIComponent(size));
    return q.length ? u + '?' + q.join('&') : u;
  }

  /* After load: the panel is an answer to a question the shopper has already
     had answered badly, not part of getting the page up. */
  function go() {
    if (!colour) return;
    count(url(true, !!size)).then(function (n) {
      if (n == null) return; // not counted: the plain sentence and its link stand
      if (n > 0) {
        write(link.getAttribute('data-label-colour'), n);
        link.href = href(true, !!size);
        return;
      }
      if (size) {
        return count(url(true, false)).then(function (m) {
          if (m == null) return;
          if (m > 0) {
            write(link.getAttribute('data-label-colour'), m);
            link.href = href(true, false);
            return;
          }
          return whole();
        });
      }
      return whole();
    });
  }

  function whole() {
    return count(url(false, false)).then(function (k) {
      link.href = base;
      if (k == null) {
        // Nothing in this colour, and the whole collection not counted: its plain sentence.
        var plain = link.getAttribute('data-label-any-plain');
        if (plain && label) label.textContent = plain;
        return;
      }
      write(link.getAttribute('data-label-any'), k);
    });
  }

  if (document.readyState === 'complete') setTimeout(go, 0);
  else window.addEventListener('load', go);
})();
